<template lang="pug">
accordion-item.poll(@load="loadObject", :isLoading="!loadingState || loadingState == 'loading'", :initial-active='initialActive', :initial-stay-active='initialStayActive', :injected='injected', ref='accordionItem')
    template(slot="header")
      vue-object-img(:object='pollObject.group')
      h3 {{pollObject.name}}
      .text-muted {{pollObject.startTime | unixtimeTo("L")}} &gt; {{pollObject.endTime | unixtimeTo("L")}}
      .menu.dropbox.doNotDesactiveOnClick
        .dropdown-toggle(data-toggle="dropdown")
          i.fa.fa-ellipsis-v
        ul.dropdown-menu.dropdown-menu-right
          //- li(v-if="canEdit")
          //-   a(@click='popupNotImplemented()')
          //-     i.fa.fa-pencil
          //-     |  {{$t("globals.edit")}}
          //- li(v-if="canPublish")
          //-   a(@click='popupNotImplemented()')
          //-     i.fa.fa-globe
          //-     |  {{$t("globals.publish")}}
          li
            a(@click='invitePeople')
              i.fa.fa-user-plus
              |  {{$t("globals.invite")}}
          //- li
          //-   a(@click='popupNotImplemented()')
          //-     i.fa.fa-clone
          //-     |  {{$t("globals.copy")}}
          li
            a(@click='deletePoll')
              i.fa.fa-trash
              |  {{$t("globals.delete")}}
    template(slot="body")
      div(v-show='currentTab == "info"')
        .row.hpadding
          .col-sm-12
            template(v-if='error') {{$t('globals.error')}}
            template(v-if='loaded')
              .box.withAuthor
                vue-object-img(:object='poll.author')
                .text 
                  .name {{pollObject.author.name}}, {{pollObject.group.name}}
                  .time(:title='poll.creationDate | unixtimeTo("L LT")') {{pollObject.creationDate | unixtimeTo("calendar") }}
                  div {{pollObject.description || $t("polls.poll.noDescription") }}
          .col-sm-12.pcenter
            .allTables
              table.pollMembers(:class='{scrolled: scrolled}')
                template(v-for='(member, index) in sortedMembers', :member='member')
                  tr.pollHeader(v-if='index % repeatHeader() == 0')
                    td(colspan='2')
                      template(v-if='index == 0')
                        .dropdown
                          .text-right.dropdown-toggle(style='padding: 5px;', @click='toggleQuickAnswer', role='button', data-toggle="dropdown")
                            .btn.btn-xs
                              i.fa.fa-bolt(:class='{pulseInfinite: hasFilter, orange: hasFilter}')
                          ul.dropdown-menu
                            template(v-if='pollEntrySeveralDays')
                              li.dropdown-header(@click.stop="toggleDays", role='button') {{$t('polls.poll.filters.days.title')}}
                              li(v-for="day,index in filter.days", v-if='hasPollEntryDay(index)')
                                a.smallEntry(@click.stop="toggleQuickAnswer") 
                                  label
                                    input(type="checkbox", checked, v-model='filter.days[index]')
                                    |  {{moment().day(index + 1).format("dddd")}}
                            template(v-if='pollEntrySeveralHours')
                              li.dropdown-header {{$t('polls.poll.filters.hours.title')}}
                              li
                                a(@click.stop="toggleQuickAnswer") 
                                  select(v-model='filter.startHour')
                                    option(v-for='hour in hours', :value='hour')
                                      | {{$t('polls.poll.filters.hours.from')}} {{hour}}:00
                                  select(v-model='filter.endHour')
                                    option(v-for='hour in hours', :value='hour')
                                      | {{$t('polls.poll.filters.hours.to')}} {{hour}}:00
                            li.divider(role='separator', v-if='pollEntrySeveralDays || pollEntrySeveralHours')
                            li.dropdown-header {{$t('polls.poll.filters.answers.title')}}
                            li
                              a(@click.stop="quickAnswer('Yes')", role="button")
                                i.fa.fa-user.green
                                |  {{$t('polls.poll.filters.answers.present')}}
                            li(v-if='isYesMaybeNo')
                              a(@click.stop="quickAnswer('Maybe')", role="button")
                                i.fa.fa-user.orange
                                |  {{$t('polls.poll.filters.answers.maybe')}}
                            li
                              a(@click.stop="quickAnswer('No')", role="button")
                                i.fa.fa-user.red
                                |  {{$t('polls.poll.filters.answers.absent')}}
                            li
                              a(@click.stop="quickAnswer(null)", role="button")
                                i.fa.fa-user
                                |  {{$t('polls.poll.filters.answers.none')}}
                            template(v-if='hasFilter')
                              li.divider(role='separator')
                              li
                                a(@click.stop="initFilters", role='button')
                                  i.fa.fa-ban
                                  |  {{$t('polls.poll.filters.reinit')}}
                  tr
                    td 
                      vue-object-img(:object='member') 
                    td(:title='member.name') {{member.name}}
                tr
                  td(colspan='2')
                tr
                  td(colspan='2')
                    | {{$t('polls.poll.total')}} 
              .pollTableDiv(@scroll='scrollDiv', ref="pollTableDiv", :class='{notFullScrolled: !fullScrolled}', debounce="500")
                table.pollTable
                  template(v-for='(member, index) in sortedMembers', :member='member')
                    tr.pollHeader(v-if='index % repeatHeader() == 0')
                      th(v-for='entry in filteredEntries', :class='{best: bestEntries.indexOf(entry) != -1}')
                        span(v-if='entry.isAboutDate && !entry.isAboutDateTime', :title='entry.text | unixtimeTo("L")')
                          | {{moment.unix(entry.text).format('dddd').substr(0,3)}}
                          br
                          | {{entry.text | unixtimeTo("thisYearDate")}}
                        span(v-if='entry.isAboutDateTime', :title='entry.text | unixtimeTo("L LT")')
                          | {{moment.unix(entry.text).format('dddd').substr(0,3)}}
                          br
                          | {{entry.text | unixtimeTo("thisYearDateTime")}}
                        span(v-if='!entry.isAboutDate') {{entry.text}}
                    tr
                      td(v-for='entry in filteredEntries', :class='{best: bestEntries.indexOf(entry) != -1}')
                        label(@click="onCellClick(member, entry)")
                          template(v-if='isYesNo || isYesMaybeNo')
                            i.fa.fa-user.editable(:class='{green: isYes(entry, member), red: isNo(entry, member), orange: isMaybe(entry, member)}')
                            //- input(type='checkbox', :checked='checkedFor(entry, member)')
                  tr
                    th(v-for='entry in filteredEntries', :class='{best: bestEntries.indexOf(entry) != -1}')
                      span(v-if='entry.isAboutDate && !entry.isAboutDateTime', :title='entry.text | unixtimeTo("L")') {{entry.text | unixtimeTo("thisYearDate")}}
                      span(v-if='entry.isAboutDateTime', :title='entry.text | unixtimeTo("L LT")') {{entry.text | unixtimeTo("thisYearDateTime")}}
                      span(v-if='!entry.isAboutDate') {{entry.text}}
                  tr
                    td(v-for='entry in filteredEntries', :class='{best: bestEntries.indexOf(entry) != -1}') {{ nbYesInEntry(entry) }}

            div.bpadding(v-if='nbWithoutAnswers > 0')
              a.clickable(@click=' toggleWithoutAnswers', v-if='!showWithoutAnswers') {{$t('polls.poll.showMembersWithoutAnswers')}}  ({{nbWithoutAnswers}})
              a.clickable(@click=' toggleWithoutAnswers', v-if='showWithoutAnswers') {{$t('polls.poll.hideMembersWithoutAnswers')}}
      div(v-show='currentTab == "conversation"')
        conversation-on-shared-object(v-if='pollObject.fullView', :shared-object='pollObject', :injected='true', :visible='currentTab == "conversation"')
      .footer.pcenter
        selectable.row.childSelection.center-block(:selected.sync="currentTab")
          .col-md-6.col-xs-6(data-value="info")
            i.fa.fa-info-circle
            | &nbsp;
            span.hidden-xs.hidden-sm {{$t('polls.poll.infos')}}
          .col-md-6.col-xs-6(data-value="conversation")
            .relative.inline.rmargin
              i.fa.fa-comments-o
              //- .badge.danger(v-if='event.conversation && event.conversation.unreadMessages > 0') {{event.conversation.unreadMessages}}
            | &nbsp;
            span.hidden-xs.hidden-sm {{$t('polls.poll.linkedConversation')}}
</template>
<script>
import eventsBus from '@/components/shared/EventsBus'

import $ from 'jquery'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import api from '@/utils/api'
import VueObjectImg from '@/components/shared/VueObjectImg'
import { unixtimeTo } from '@/components/shared/vue.globals'
import AccordionItem from '@/components/shared/Accordion/Accordion-Item'
import ConversationOnSharedObject from '@/components/Conversations/ConversationOnSharedObject'
import Selectable from '@/components/shared/Selectable'
import moment from 'moment'

import Noty from '@/components/shared/Notify'

import modalsBus from '@/components/shared/ModalsBus'

import swal from 'sweetalert2'
import Vue from 'vue'

export default {
  props: ['poll', 'initialActive', 'initialStayActive'],
  data() {
    this.defaultFilter = {
      days: [...Array(7)].map(v => true),
      startHour: 0,
      endHour: 0
    }

    return {
      scrolled: false,
      fullScrolled: true,
      loadingState: false,
      showWithoutAnswers: false,
      nbWithoutAnswers: 0,
      active: this.initialActive || false,
      stayActive: this.initialStayActive || false,
      injected: false,
      pollObject: this.poll,
      currentTab: 'info',
      quickAnswerEnabled: true,
      filter: _.cloneDeep(this.defaultFilter),
      moment: moment
    }
  },
  components: {
    VueObjectImg,
    AccordionItem,
    ConversationOnSharedObject,
    Selectable
  },
  filters: {
    unixtimeTo
  },
  created() {
    this.scrollDivFn = () => {
      return requestAnimationFrame(() => {
        const $tableDiv = $(this.$refs.pollTableDiv)
        const $table = $('table', this.$refs.pollTableDiv)
        const scrollLeft = $tableDiv.scrollLeft()
        this.scrolled = scrollLeft !== 0
        this.fullScrolled = $tableDiv.width() + scrollLeft === $table.width()
      })
    }

    if (this.active) {
      return this.loadObject()
    }
  },
  mounted() {
    return this.$nextTick(() => {
      return $(window).on('resize.polls', () => {
        return this.scrollDivFn()
      })
    })
  },
  destroyed() {
    return this.$nextTick(() => {
      return $(window).off('resize.polls')
    })
  },

  computed: {
    ...mapGetters('user', ['user']),
    accordionItem() {
      // needed for Accordion
      return this.$refs.accordionItem
    },
    loading() {
      return this.loadingState === 'loading'
    },
    error() {
      return this.loadingState === 'error'
    },
    loaded() {
      return this.loadingState === 'loaded'
    },
    hours() {
      return [...Array(24).keys()]
    },
    sortedMembers() {
      if (this.pollObject.members == null) {
        return []
      }
      this.$nextTick(() => {
        return this.scrollDivFn()
      })
      let { members } = this.pollObject
      let nbWithoutAnswers = 0
      if (!this.showWithoutAnswers) {
        members = members.filter(m => {
          if (this.user.id === m.id) {
            // the current user is always shown
            return true
          }

          for (let entry of Array.from(this.pollObject.entries)) {
            if (entry.answers[m.id] != null) {
              return true
            }
          }
          nbWithoutAnswers++
          return false
        }) // no answer for this user
        this.nbWithoutAnswers = nbWithoutAnswers
      }
      return members.sort((a, b) => {
        if (this.user.id === a.id) {
          return -1
        }
        if (this.user.id === b.id) {
          return 1
        }
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1
        }
        return 0
      })
    },
    hasPollEntryTime() {
      return (
        this.pollObject.entries &&
        this.pollObject.entries.find(entry => entry.isAboutDateTime) !==
          undefined
      )
    },
    hasFilter() {
      return (
        this.filter.days.find(z => !z) !== undefined ||
        this.filter.startHour ||
        this.filter.endHour
      )
    },
    filteredEntries() {
      return (
        this.pollObject.entries &&
        this.pollObject.entries.filter(e => {
          if (e.isAboutDate) {
            let m = moment.unix(e.text)
            if (!this.filter.days[(m.day() + 6) % 7]) {
              return false
            }
            if (e.isAboutDateTime) {
              if (m.hour() < this.filter.startHour) {
                return false
              }
              if (this.filter.endHour && m.hour() > this.filter.endHour) {
                return false
              }
            }
          }
          return true
        })
      )
    },
    bestEntries() {
      const best = {
        entries: [],
        nbYes: -1
      }
      for (let entry of Array.from(this.pollObject.entries)) {
        const nbYes = this.nbYesInEntry(entry)
        if (best.nbYes < nbYes) {
          best.entries = [entry]
          best.nbYes = nbYes
        } else if (best.nbYes === nbYes) {
          best.entries.push(entry)
        }
      }
      return best.entries
    },
    isYesNo() {
      return (
        this.pollObject.possibleAnswers.indexOf('Yes') > -1 &&
        this.pollObject.possibleAnswers.indexOf('Maybe') === -1
      )
    },
    isYesMaybeNo() {
      return this.pollObject.possibleAnswers.indexOf('Maybe') > -1
    },
    is1to5() {
      return this.pollObject.possibleAnswers === [1, 2, 3, 4, 5]
    },
    is1to10() {
      return this.pollObject.possibleAnswers === [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    },
    canEdit() {
      return (
        this.pollObject.permissions != null && this.pollObject.permissions.EDIT
      )
    },
    canPublish() {
      return (
        this.pollObject.permissions != null &&
        this.pollObject.permissions.PUBLISH
      )
    },
    pollEntrySeveralDays() {
      let day = null
      return (
        this.pollObject.entries &&
        this.pollObject.entries.find(entry => {
          if (entry.isAboutDate) {
            if (day === null) {
              day = moment.unix(entry.text).day()
            } else if (day !== moment.unix(entry.text).day()) {
              return true
            }
          }
          return false
        }) !== undefined
      )
    },
    pollEntrySeveralHours() {
      let hour = null
      return (
        this.pollObject.entries &&
        this.pollObject.entries.find(entry => {
          if (entry.isAboutDateTime) {
            if (hour === null) {
              hour = moment.unix(entry.text).hour()
            } else if (hour !== moment.unix(entry.text).hour()) {
              return true
            }
          }
          return false
        }) !== undefined
      )
    }
  },
  methods: {
    hasPollEntryDay(day) {
      return (
        this.pollObject.entries &&
        this.pollObject.entries.find(
          entry =>
            entry.isAboutDate && (moment.unix(entry.text).day() - 1 + 7) % 7 === day
        ) !== undefined
      )
    },
    initFilters() {
      this.filter = _.cloneDeep(this.defaultFilter)
    },
    toggleDays() {
      this.filter.days = this.filter.days.map(active => !active)
    },
    nbYesInEntry(entry) {
      if (entry.nbYes != null) {
        return entry.nbYes
      }
      let nb = 0
      for (let index in entry.answers) {
        const answer = entry.answers[index]
        if (answer === 'Yes') {
          nb++
        }
      }
      this.$set(entry, 'nbYes', nb)
      return nb
    },
    onCellClick(member, entry) {
      if (member.id === this.user.id) {
        if (!this.pollObject.permissions.CHANGE_OWN_ANSWER) {
          return
        }
      } else {
        if (!this.pollObject.permissions.CHANGE_OTHER_ANSWERS) {
          return
        }
      }
      let newAnswer = 'Yes'
      if (this.isYes(entry, member)) {
        if (this.pollObject.possibleAnswers.indexOf('Maybe') > -1) {
          newAnswer = 'Maybe'
        } else {
          newAnswer = 'No'
        }
      } else if (this.isMaybe(entry, member)) {
        newAnswer = 'No'
      } else if (this.isNo(entry, member)) {
        newAnswer = null
      }
      return this.changeAnswer(member, entry, newAnswer)
    },
    toggleQuickAnswer() {
      this.quickAnswerEnabled = !this.quickAnswerEnabled
    },
    toggleWithoutAnswers() {
      this.showWithoutAnswers = !this.showWithoutAnswers
      this.$nextTick(() => {
        this.$refs.accordionItem.updateLayout()
      })
    },
    checkedFor(entry, member) {
      return (
        entry.answers[member.id] != null && entry.answers[member.id] === 'Yes'
      )
    },
    // return a.length != 0 && a[0].answer == "Yes"
    repeatHeader() {
      // returns the number of row to display before repeat the header
      return Math.ceil(($(window).height() - 300) / 40)
    },

    scrollDiv() {
      return this.scrollDivFn()
    },
    isYes(entry, member) {
      return entry.answers[member.id] === 'Yes'
    },
    isNo(entry, member) {
      return entry.answers[member.id] === 'No'
    },
    isMaybe(entry, member) {
      return entry.answers[member.id] === 'Maybe'
    },
    quickAnswer(answer) {
      let data = []
      for (let entry of this.filteredEntries) {
        data.push({ entry: entry, answer: answer, oldAnswer: entry.answers[this.user.id] })
        this.innerChangeAnswer(this.user, entry, answer)
      }
      let member = this.user
      if (data.length > 0) {
        eventsBus.$emit(eventsBus.SHOW_LOADING)
        return api
          .post(`/poll/${this.pollObject.id}/answers`, {
            mid: member.id,
            data: data.map((o) => { return {eid: o.entry.id, answer: o.answer} })
          })
          .then(() => {
            eventsBus.$emit(eventsBus.HIDE_LOADING)
            this.$store.dispatch('toAnswer/refresh')
            for (let o of data) {
              if (o.oldAnswer === 'Yes' && o.answer !== 'Yes') {
                o.entry.nbYes--
              } else if (o.answer === 'Yes' && o.oldAnswer !== 'Yes') {
                o.entry.nbYes++
              }
            }
            new Noty({
              text: this._i18n.t('polls.notify.userAnswer.ok'),
              type: 'success'
            }).show()
          })
          .catch(() => {
            eventsBus.$emit(eventsBus.HIDE_LOADING)
            for (let o of data) {
              this.innerChangeAnswer(this.user, o.entry, o.oldAnswer)
            }
            new Noty({
              text: this._i18n.t('polls.notify.userAnswer.ko'),
              type: 'error'
            }).show()
          })
      }
    },
    innerChangeAnswer(member, entry, answer) {
      this.$set(entry.answers, member.id, answer)
    },
    changeAnswer(member, entry, answer, silently = false) {
      const oldAnswer = entry.answers[member.id]
      this.innerChangeAnswer(member, entry, answer)
      return api
        .post(`/poll/${this.pollObject.id}/answer`, {
          mid: member.id,
          eid: entry.id,
          answer
        })
        .then(() => {
          this.$store.dispatch('toAnswer/refresh')
          if (oldAnswer === 'Yes' && answer !== 'Yes') {
            entry.nbYes--
          } else if (answer === 'Yes' && oldAnswer !== 'Yes') {
            entry.nbYes++
          }
          if (!silently) {
            new Noty({
              text: this._i18n.t('polls.notify.userAnswer.ok'),
              type: 'success'
            }).show()
          }
        })
        .catch(() => {
          this.$set(entry.answers, member.id, oldAnswer)
          new Noty({
            text: this._i18n.t('polls.notify.userAnswer.ko'),
            type: 'error'
          }).show()
        })
    },
    loadObject() {
      if (this.pollObject.fullView) {
        this.loadingState = 'loaded'
      }
      if (!this.pollObject.fullView && !this.loading) {
        this.loadingState = 'loading'
        return api
          .get(`/poll/${this.pollObject.id}`)
          .then(response => {
            this.pollObject = response.data
            this.loadingState = 'loaded'
            return this.scrollDivFn()
          })
          .catch(() => {
            this.loadingState = 'error'
          })
      }
    },
    popupNotImplemented() {
      // return vm.popupNotImplemented();
    },
    invitePeople() {
      modalsBus.open(
        modalsBus.modals.MANAGE_RESTRICTED_VIEWERS,
        this.pollObject
      )
    },
    deletePoll() {
      swal({
        title: Vue.i18n.t('globals.askBeforeDelete'),
        text: '',
        type: 'warning',
        showCancelButton: true
      }).then(
        () => {
          let notification = new Noty({
            text: Vue.i18n.t('globals.deleting'),
            type: 'info',
            timeout: false
          })
          notification.show()
          this.$store
            .dispatch('polls/deletePoll', this.poll)
            .then(() => {
              notification.close()
              setTimeout(() => {
                new Noty({
                  text: Vue.i18n.t('globals.deleted'),
                  type: 'success'
                }).show()
              }, 500)
            })
            .catch(() => {
              notification.close()
              setTimeout(() => {
                new Noty({
                  text: Vue.i18n.t('globals.error'),
                  type: 'error',
                  timeout: 5000
                }).show()
              }, 500)
            })
        },
        () => {}
      )
    }
  },

  watch: {
    active(newValue) {
      return this.loadObject()
    },
    currentTab() {
      this.$nextTick(() => {
        this.$refs.accordionItem.assureItemIsVisible()
        this.$refs.accordionItem.updateLayout()
      })
    },
    filteredEntries() {
      this.$nextTick(() => this.scrollDivFn())
    },
    'filter.startHour'() {
      if (this.filter.endHour && this.filter.startHour > this.filter.endHour) {
        this.filter.endHour = 0
      }
    },
    'filter.endHour'() {
      if (this.filter.endHour && this.filter.startHour > this.filter.endHour) {
        this.filter.startHour = 0
      }
    }
  }
}
</script>
<style lang="sass">
.pollTable td
  min-width: 60px
.pollsList .pollMembers tr td .smallEntry
  label
    line-height: 25px
    height: 25px
</style>




// WEBPACK FOOTER //
// Poll.vue?3ba1ffbe